import { useQuery } from 'react-query'
import ApiClient from '@quiqupltd/quiqupjs/lib/network/api-client'
import { useEnvVars } from './useEnvVars'

// ApiClient camelCases JSON response keys
export type ReturnRequestStatus = {
  id: string
  status: 'submitted' | 'pending' | 'approved' | 'rejected' | 'approvedPendingBooking'
  createdAt: string
  approvedAt?: string
  rejectedAt?: string
  rejectionReason?: string
  returnTrackingUrl?: string
}

const TERMINAL_STATUSES = ['approved', 'rejected']

export function useReturnStatus(requestId?: string) {
  const { env } = useEnvVars()

  return useQuery<ReturnRequestStatus>(
    ['return-status', requestId],
    () =>
      ApiClient.get({
        path: `${env.QUIQUP_PLATFORM_URL}/api/return-requests/${requestId}/status`,
        includeAuth: false,
      }),
    {
      enabled: !!requestId,
      refetchInterval: (data) =>
        data && TERMINAL_STATUSES.includes(data.status) ? false : 30_000,
    }
  )
}
